"use client";

import { useIsMobile } from "@nimble/react-state-hooks/use-mobile";
import { useMemo } from "react";

import MapContainer, {
  MapContainerProps,
} from "@/components/shared/map/map.container";
import { MapPopupComponenType } from "@/components/shared/map/types";
import MapSchoolCard from "@/components/shared/school/school-card/map-school-card";
import MobileSchoolDetailsContainer from "@/components/shared/school/school-details/mobile-school-details.container";
import { StateConfig } from "@/lib/states-config";

type MapWithSchoolCardContainerProps = MapContainerProps & {
  stateConfig: StateConfig;
};

export default function MapWithSchoolCardContainer({
  stateConfig,
  ...props
}: MapWithSchoolCardContainerProps) {
  const isMobile = useIsMobile();

  const PopupComponent = useMemo(() => {
    const Component: MapPopupComponenType = (props) => {
      if (isMobile) {
        return (
          <MobileSchoolDetailsContainer stateConfig={stateConfig} {...props} />
        );
      }

      return <MapSchoolCard stateConfig={stateConfig} {...props} />;
    };

    return Component;
  }, [isMobile, stateConfig]);

  return (
    <div className="h-[calc(100dvh-350px)] sm:h-[400px] md:h-[700px] w-full min-h-[350px]">
      <MapContainer {...props} PopupComponent={PopupComponent} />
    </div>
  );
}
